import { useSyncExternalStore } from "react";

/**
 * Subscribe a React component to a store class. Re-renders whenever the
 * store's `subscribe(listener)` fires, then reads the latest value via
 * `selector(store)`.
 *
 *   const insuredProfile = useStore(insuredProfileStore, (s) => s.insuredProfile);
 *   const zip = useStore(quoteStore, (s) => s.zip);
 *
 * `selector` lets a component subscribe to a single field without
 * re-rendering when unrelated fields in the same domain change. Pass
 * `(s) => s` if you actually want the whole store object.
 */
export function useStore(store, selector) {
  return useSyncExternalStore(
    (listener) => store.subscribe(listener),
    () => selector(store),
    () => selector(store),
  );
}
